import { Nullable } from '@app/models/nullable'
import { environment } from 'src/environments/environment'

interface GetEndpointOptions {
  queryParams: {
    [key: string]: any
  }
}

export const getEndpoint = (
  segments: string[],
  options: Nullable<GetEndpointOptions> = null
) => {
  const { apiBase, apiVersion } = environment
  let endpoint: string = [apiBase, apiVersion, ...segments].join('/')
  if (!!options) {
    const paramList = Object.keys(options.queryParams).map(
      (i) => `${i}=${options.queryParams[i]}`
    )
    endpoint = `${endpoint}?${paramList.join('&')}`
  }

  return endpoint
}

